import { type V2TermsCategoryResponseDto, type V2TermsVersionCreateRequestDtoCategory } from "@everon-it/api-client/contents-gw";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export type CategoryInfoType = Omit<Partial<V2TermsCategoryResponseDto>, "category"> & {
    category?: V2TermsVersionCreateRequestDtoCategory;
    isRequired?: boolean;
    isVisibleOnSignup?: boolean;
    isVisibleOnServicePage?: boolean;
};

type TermsDataStore = {
    categoryInfo: CategoryInfoType;
    setCategoryInfo: (data: CategoryInfoType) => void;
};

const initialCategoryInfo: CategoryInfoType = {
    category: undefined,
    title: "",
    description: "",
    displayOrder: undefined,
    isRequired: undefined,
    isVisibleOnSignup: undefined,
    isVisibleOnServicePage: undefined,
};

const useTermsDataStore = create<TermsDataStore>()(
    persist(
        set => ({
            categoryInfo: { ...initialCategoryInfo },
            setCategoryInfo: data => set({ categoryInfo: { ...data } }),
        }),
        {
            name: "termsCategoryInfo",
            storage: createJSONStorage(() => localStorage),
        },
    ),
);

export default useTermsDataStore;
